/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.roles.RoleSubjectType
*/
export var RoleSubjectType;
(function (RoleSubjectType) {
    RoleSubjectType["USER"] = "USER";
    RoleSubjectType["TEAM"] = "TEAM";
})(RoleSubjectType || (RoleSubjectType = {}));
//# sourceMappingURL=RoleSubjectType.js.map